import eq from "lodash-es/eq"
import { useIsomorphicLayoutEffect, usePrevious } from "react-use"

import type { TEmptyAsyncCallback } from "@/shared/types/functions"

import { useCoachingChatConversationQueryRefetch as useConversationRefetch } from "../api"
import {
    useCoachingChatConversationApiMode as useConversationApiMode,
    useCoachingChatConversationIdSelector as useConversationIdSelector
} from "../store"
import {
    ECoachingChatConversationApiMode as EConversationApiMode,
    type _TCoachingChatHookSharedParams as _TSharedParams
} from "../types"

function useCoachingChatApiSwitchReloader({ entityId }: Pick<_TSharedParams, "entityId">): void {
    const apiMode: EConversationApiMode = useConversationApiMode()

    const prevApiMode: EConversationApiMode = usePrevious<EConversationApiMode>(apiMode)

    const conversationId: number = useConversationIdSelector(entityId)

    const conversationReFetcher: TEmptyAsyncCallback = useConversationRefetch(conversationId)

    useIsomorphicLayoutEffect((): void => {
        // Keep the rendered conversation intact while REST synchronises anything
        // missed during the websocket outage.
        if (eq(apiMode, EConversationApiMode.Rest) && eq(prevApiMode, EConversationApiMode.Sockets))
            void conversationReFetcher()
    }, [apiMode, prevApiMode, conversationReFetcher])
}

export { useCoachingChatApiSwitchReloader }
